import { Url } from '../shared/Url';
import Post from '../shared/Post';
import { consultaUser } from './PefilFunction';
import { cookieData } from '../funciones/ConsultaUser';

export const BusquedaEst = (string, respuesta) => {
    consultaUser ((usuario) => {
        let Content = {
            user: usuario,
            strings: string
        }

        Post(`${Url}consultaEst`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data[0])
        });
    });
}

export const SolicitudesCambCarrera = (respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1]
        }

        Post(`${Url}solicitudesCambCarrera`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data.data)
        });
    })
}

export const AprobCambioCarrera = (id, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            id: id
        }

        Post(`${Url}aprobCambioCarrera`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data.data)
        });
    })
}

export const NoAprobCambioCarrera = (id, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            id: id
        }

        Post(`${Url}noAprobCambioCarrera`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data.data)
        });
    })
}

export const CambiaSeccionEst = (secAct, nuevaSec, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            secAct: secAct,
            nuevaSec: nuevaSec
        }

        Post(`${Url}CambiaSeccionEst`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta (data)
        })
    })
}

export const EstRetiroMatDir = (respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1]
        }

        Post(`${Url}EstRetiroMatDir`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta (data[0])
        })
    })
}

export const EstRetiroDir = (respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1]
        }

        Post(`${Url}EstRetiroDir`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta (data[0])
        })
    })
}

export const ProcesarEstRetiroDir = (id, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            id: id
        }

        Post(`${Url}ProcesarEstRetiroDir`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta (data)
        })
    })
}

export const RetirarMateriaDir = (id, materia, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            mId: id,
            materia: materia
        }

        Post(`${Url}RetirarMateriaDir`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta (data)
        })
    })
}

export const NoRetirarMateriaDir = (id, materia, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            mId: id,
            materia: materia
        }

        Post(`${Url}NoRetirarMateriaDir`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta (data)
        })
    })
}

export const MatInscritasDir = (idEst, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            idEst: idEst
        }

        Post(`${Url}MatInscritasDir`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta (data[0])
        })
    })
}

export const BusquedaEstIndDir = (strings, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            strings: strings
        }

        Post(`${Url}BusquedaEstIndDir`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta (data[0])
        })
    })
}

export const ConsultEmail = (id, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            id: id
        }

        Post(`${Url}consultaEstEmail`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta (data)
        })
    })
}

export const CambiarEmail = (id, email, respuesta) => {
    let expReg = /^(?:[^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*|"[^\n"]+")@(?:[^<>()[\].,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,63}$/i;
    let errores = 0;
    let mess = "Se ha actualizado el Email correctamente y se ha enviado un correo con la contraseña al usuario";
    let messType = "info";

    if (email === "") {
        errores++;
        mess = "El campo Email es obligatorio";
        messType = "error"; 
    }

    if (expReg.test(email) === false) {
        errores++;
        mess = "El campo Email debe tener el formato correcto";
        messType = "error"; 
    }

    if (errores === 0) {
        cookieData((cookie) => {
            let Content = {
                uId: cookie[1],
                id: id,
                email: email
            }
    
            Post(`${Url}cambiaEstEmail`, Content, (resp) => {
                let data = JSON.parse(resp);
                if (data.status === "warning"){
                    mess = data.mess;
                    messType = "error";
                }

                respuesta ([mess, messType])
            })
        })
    }else{
        respuesta ([mess, messType])
    }
    
}

export const BusquedaEstInd = (id, respuesta) => {
    if (id === "") return null;
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            estId: id
        }

        Post(`${Url}consultaEstData`, Content, (resp) => {
            let data = JSON.parse(resp);
            let notificacionClass = "custom-alert-info";
            let notificacionIcon = "fa fa-circle-o-notch fa-spin";
            let notificacionText = "Verificando Información, espera por favor";
            switch (parseInt(data.status)) {
                case 0:
                    notificacionClass = "custom-alert-info";
                    notificacionIcon = "fa fa-exclamation-triangle";
                    notificacionText = "Este estudiante no está inscrito";
                break;
                case 1:
                    notificacionClass = "custom-alert-warning";
                    notificacionIcon = "fa fa-exclamation-triangle";
                    notificacionText = "Este estudiante está pendiente por pago de aranceles";
                    break;
                case 2:
                    notificacionClass = "custom-alert-danger";
                    notificacionIcon = "fa fa-times";
                    notificacionText = "La inscripción de este estudiante no está aprobada";
                break;
                case 3:
                    notificacionClass = "custom-alert-success";
                    notificacionIcon = "fa fa-check";
                    notificacionText = "Este estudiante se encuentra inscrito";
                break;
                case 4:
                    notificacionClass = "custom-alert-danger";
                    notificacionIcon = "fa fa-times";
                    notificacionText = "Este estudiante tiene abierta una solicitud de cambio de carrera, debes primero atender esta petición";
                break;
                case 5:
                    notificacionClass = "custom-alert-warning";
                    notificacionIcon = "fa fa-exclamation-triangle";
                    notificacionText = "Estudiante pendiente de Aprobación de Control de Estudios";
                break;
                case 6:
                    notificacionClass = "custom-alert-danger";
                    notificacionIcon = "fa fa-exclamation-triangle";
                    notificacionText = "Este estudiante no tiene Estado de Cuenta";
                break;
                case 7:
                    notificacionClass = "custom-alert-danger";
                    notificacionIcon = "fa fa-exclamation-triangle";
                    notificacionText = "Este estudiante actualmente tiene una Deuda Pendiente";
                break;
                case 8:
                    notificacionClass = "custom-alert-warning";
                    notificacionIcon = "fa fa-exclamation-triangle";
                    notificacionText = "Este estudiante actualmente tiene un Pago Pendiente por Aprobación";
                break;
                default:
                    notificacionClass = "custom-alert-warning";
                    notificacionIcon = "fa fa-exclamation-triangle";
                    notificacionText = "Este estudiante no está inscrito";
                break;
            }

            let semestres = [];
            let dataSemestres = data.semestres
            for (let i in dataSemestres) {
                semestres.push({
                    value: dataSemestres[i].id,
                    label: dataSemestres[i].semestre_name,
                })
            }

            let materiasInsc = [];
            let materiasInsc2 = [];
            let uc = 0;
            let dataInscritas = data.inscritas
            for (let i in dataInscritas) {
                uc += parseInt(dataInscritas[i].u_c);
                materiasInsc.push(
                    dataInscritas[i].id_seccion
                )
                materiasInsc2.push({
                    id: dataInscritas[i].id_seccion,
                    tipo: dataInscritas[i].tipo_curso,
                    uc: parseInt(dataInscritas[i].u_c)
                })
            }

            let state = {
                dataInscripcion: data.carrera,
                semestres: semestres,
                notificacionClass: notificacionClass,
                notificacionIcon: notificacionIcon,
                notificacionText: notificacionText,
                seccionesSelectFull: materiasInsc,
                seccionesSelectFull2: materiasInsc,
                seccionesSelectFull3: materiasInsc2,
                cr: uc,
            }
            respuesta([state, parseInt(data.status), uc, data.status, data.usu]);
        }); 
    })
}

export const BuscaInscrito = (id, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            id: id
        }

        Post(`${Url}BuscaInscrito`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta (data)
        })
    })
}

export const CheckMateria = (seccion, est, respuesta) => {
    let Content = {
        est: est,
        seccion: seccion
    }
    Post(`${Url}checkMateria`, Content, (resp) => {
        let data = JSON.parse(resp);
        respuesta(data)
    }); 
}

export const Inscribir = (matInscr, estudiante, campos, uc, respuesta) => {
    cookieData((cookie) => {
        Post(`${Url}preferencias`, "", (resp) => {
            let data = JSON.parse(resp);
            let UcMin = data[0][0].min_uc;
            let UcMax = data[0][0].max_uc;
            let MateMin = data[0][0].min_mate;
            let MateMax = data[0][0].max_mate;
            let MateInscritas = campos.seccionesSelectFull.length;
            let Materias = campos.seccionesSelectFull;
            let notificacionText = "Haz modificado el proceso de inscripción del estudiante";
            let typeNotificacion = "info";

            /* Validaciones */
            let errores = 0;

            if (campos.valorSemestres.value === "") {
                notificacionText = `Selecciona el Semestre para continuar`
                typeNotificacion = "error";
                errores++; 
            }else{
                if (UcMin === 0 && UcMax === 0){
                    errores = errores
                }else{
                    if (uc < UcMin) {
                        notificacionText = `El mínimo de Unidades de Crédito que puedes inscribir es [ ${UcMin} ]`
                        typeNotificacion = "error";
                        errores++;
                    }
                    
                    if (uc > UcMax) {
                        notificacionText = `El máximo de Unidades de Crédito que puedes inscribir es [ ${UcMax} ]`
                        typeNotificacion = "error";
                        errores++;
                    }
                }
        
                if (MateMin === 0 && MateMax === 0){
                    errores = errores
                }else{
                    if (MateInscritas < MateMin) {
                        notificacionText = `El mínimo de Materias que puedes inscribir es [ ${MateMin} ]`
                        typeNotificacion = "error";
                        errores++;
                    }
                    if (MateInscritas > MateMax) {
                        notificacionText = `El máximo de Materias que puedes inscribir es [ ${MateMax} ]`
                        typeNotificacion = "error";
                        errores++;
                    }
                }
            }

            if (errores === 0) {
                let Content = {
                    UcMin: UcMin,
                    UcMax: UcMax,
                    MateMin: MateMin,
                    MateMax: MateMax,
                    MateInscritas: MateInscritas,
                    Uc: uc,
                    Est: estudiante,
                    Materias: Materias,
                    uId: cookie[1],
                    matIns: matInscr
                }
                
                Post(`${Url}addAllInscripcion`, Content, (resp) => {
                    let data = JSON.parse(resp);
                    let state = "";
                    if(data.status === "sc") {
                        state = {
                            Text: "No se agregaron las materias debido a que una o mas secciones se encuentran sin cupos disponibles, presiona F5 para recargar",
                            Type: "error",
                            MateMax: MateMax,
                            errores: 1
                        }
                    }else{
                        state = {
                            Text: notificacionText,
                            Type: typeNotificacion,
                            MateMax: MateMax,
                            errores: errores
                        }
                    }
                    
                    respuesta(state);
                });
            }else{
                let state = {
                    Text: notificacionText,
                    Type: typeNotificacion,
                    errores: errores
                }
        
                respuesta(state);
            }


        });
    });
}

export const RetirarEst = (id, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            est: id
        }

        Post(`${Url}RetirarEstDir`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta (data)
        })
    })
}



// WEBPACK FOOTER //
// ./src/funciones/EstudiantesFunction.jsx